<template>
  <div>
    <page-title-header
      :category-slug="categorySlug"
      class="scroll-effect"
      :class="{ 'is-active': isLoaded }"
    ></page-title-header>
    <!-- About Us Text -->
    <div class="left-col-container">
      <div
        class="container scroll-effect"
        :class="{ 'is-active': isLoaded }"
      >
        <div class="row">
          <div class="col-sm-9 left-col-text">
            <h1>{{ titleText }}</h1>
            <div
              v-if="posts.length > 0"
              class="panel panel-default"
            >
              <div class="table-responsive">
                <table class="table table-striped">
                  <tbody id="articles">
                    <tr
                      v-for="post in posts"
                      :key="post.postId"
                    >
                      <td>{{ dateFormat(post.publishAt, 'Y/M/D') }}</td>
                      <td width="7%">
                        <router-link
                          v-if="checkEmpty(post.categorySlug) === false"
                          :to="{ path: '/posts/', query: { category: post.categorySlug } }"
                          :class="getCateLabelClass(post.categorySlug)"
                          v-text="getCategoryLabel(post.categorySlug)"
                        ></router-link>
                      </td>
                      <td>
                        <router-link :to="{ path: '/posts/', query: { id: post.slug } }">{{
                          post.title
                        }}</router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <nav
                v-if="hasNext"
                class=""
              >
                <button
                  @click="fetchPosts()"
                  type="button"
                  class="btn-link btn-lg btn-block u-fs-16"
                >
                  もっと見る
                </button>
              </nav>
            </div>

            <div
              v-else-if="isLoading === false"
              class="panel panel-default"
            >
              <p>指定のお知らせはありません</p>
            </div>

            <div
              v-if="categorySlug === 'entry'"
              class="mt-8"
            >
              <iframe
                src="https://docs.google.com/spreadsheets/d/e/2PACX-1vTcMxzMcRJLAwTubrjaNqymvy4PoZ4pkbxRp-rwe2rWtYbxZs77mOPEZ-L-3cEariFHl7dOvETfkUSi/pubhtml?widget=true&amp;headers=false"
                style="width: 100%; border: none; height: 250px"
              ></iframe>
            </div>
          </div>
          <side-menu
            :category-slug="categorySlug"
            class="js-scroll-effect scroll-effect"
            data-start-pos="200"
          ></side-menu>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EasyScrollEffect from 'easy-scroll-effect'
import config from '@/config/config'
import media from '@/util/media'
import uri from '@/util/uri'
import { Post } from '@/api'
import FbImg from '@/components/atoms/FbImg'
import PageTitleHeader from '@/components/organisms/PageTitleHeader'
import SideMenu from '@/components/organisms/SideMenu'

export default {
  name: 'Posts',

  components: {
    FbImg,
    PageTitleHeader,
    SideMenu,
  },

  metaInfo() {
    return {
      title: this.titleText ? this.titleText : '記事一覧',
      meta: [
        {
          name: 'description',
          content: this.description ? this.description : '記事一覧です',
        },
      ],
    }
  },

  data() {
    return {
      pageName: 'posts',
      cateLabels: {
        report: 'warning',
        entry: 'success',
        info: 'info',
      },
      isLoaded: false,
    }
  },

  computed: {
    categorySlug() {
      return this.$route.query.category
    },

    tagLabel() {
      return this.$route.query.tag
    },

    posts() {
      return this.$store.state.posts.items
    },

    pagerKey() {
      return this.$store.state.posts.pagerKey
    },

    listCount() {
      return this.config.count
    },

    hasNext() {
      return this.$store.state.posts.pagerKey != null
    },

    isActivityCategory() {
      return this.activityCategorySlugs.includes(this.categorySlug)
    },

    isInfoCategory() {
      return this.infoCategorySlugs.includes(this.categorySlug)
    },

    titleText() {
      if (this.tagLabel) {
        return `タグ「${this.tagLabel}」の記事一覧`
      } else if (this.isActivityCategory) {
        const labels = config.post.category.titleLabels
        if (this.checkObjHasProp(labels, this.categorySlug) === true) {
          return labels[this.categorySlug]
        }
        return '組合員活動一覧'
      } else if (this.isInfoCategory) {
        return 'お知らせ一覧'
      } else {
        return 'お知らせ すべて'
      }
    },

    description() {
      return `${config.siteName} の ${this.titleText} です。`
    },
  },

  watch: {
    async categorySlug(val) {
      this.resetPosts()
      await this.fetchPosts()
    },

    async tagLabel(val) {
      this.resetPosts()
      await this.fetchPosts()
    },
  },

  mounted() {
    EasyScrollEffect.init()
  },

  destroyed() {
    EasyScrollEffect.destroy()
  },

  async created() {
    if (this.posts.length === 0) await this.fetchPosts()
    setTimeout(() => {
      this.isLoaded = true
    }, 500)
  },

  methods: {
    resetPosts() {
      this.$store.dispatch('resetPosts')
    },

    async fetchPosts() {
      let params = { withCategory: 0 }
      if (this.pagerKey != null) {
        params.pagerKey = JSON.stringify(this.pagerKey)
      }
      params.count = this.listCount
      if (this.categorySlug) {
        params.category = this.categorySlug
      } else if (this.tagLabel) {
        params.tag = this.tagLabel
      }
      this.$store.dispatch('setLoading', true)
      try {
        const res = await Post.getPosts(this.serviceId, null, params)
        this.$store.dispatch('setPosts', res)
        this.$store.dispatch('setLoading', false)
      } catch (err) {
        console.log(err) //!!!!!!
        this.$store.dispatch('setLoading', false)
      }
    },

    getCateLabelClass(cateSlug) {
      const classSuffix = this.cateLabels[cateSlug] ? this.cateLabels[cateSlug] : 'default'
      return `label label-${classSuffix}`
    },
  },
}
</script>
<style scoped>
.u-fs-16 {
  font-size: 16px;
}
.mt-8 {
  margin-top: 32px;
}
</style>
